// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BulbOutlinedSvg from "@ant-design/icons-svg/es/asn/BulbOutlined";
import AntdIcon from '../components/AntdIcon';

var BulbOutlined = function BulbOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: BulbOutlinedSvg
  }));
};

BulbOutlined.displayName = 'BulbOutlined';
export default React.forwardRef(BulbOutlined);